/* elestablo 2026 · Línea (colección) y búsqueda — agente C.
   Mejora progresiva: sin este archivo todo funciona con formularios GET y enlaces normales. */
(function () {
  'use strict';

  function dialogoDe(boton) {
    return document.getElementById(boton.getAttribute('aria-controls'));
  }

  // Abrir / cerrar el cajón de filtros (<dialog> nativo: foco atrapado y Esc de serie).
  document.addEventListener('click', function (e) {
    var abrir = e.target.closest('[data-ee-abrir-filtros]');
    if (abrir) {
      var d = dialogoDe(abrir);
      if (d && typeof d.showModal === 'function') {
        e.preventDefault();
        d.showModal();
        abrir.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    var cerrar = e.target.closest('[data-ee-cerrar-filtros]');
    if (cerrar) {
      var dlg = cerrar.closest('dialog');
      if (dlg) dlg.close();
    }
  });

  document.querySelectorAll('dialog.ee-filtros').forEach(function (d) {
    // Tocar el fondo oscuro cierra el cajón.
    d.addEventListener('click', function (e) {
      if (e.target === d) d.close();
    });
    d.addEventListener('close', function () {
      var b = document.querySelector('[aria-controls="' + d.id + '"]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });

  // Formularios GET: no mandar parámetros vacíos (precio sin llenar) para que la URL quede limpia.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-ee-form-listado]')) return;
    e.preventDefault();
    var datos = new FormData(f);
    var params = new URLSearchParams();
    datos.forEach(function (valor, nombre) {
      if (String(valor).trim() !== '') params.append(nombre, valor);
    });
    var destino = f.getAttribute('action') || window.location.pathname;
    var qs = params.toString();
    window.location.href = destino + (qs ? (destino.indexOf('?') > -1 ? '&' : '?') + qs : '');
  });

  // Ordenar: aplicar apenas se elige una opción.
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-ee-orden]');
    if (!s || !s.form) return;
    if (typeof s.form.requestSubmit === 'function') s.form.requestSubmit();
    else s.form.submit();
  });

  // "Cargar más productos": trae la página siguiente y agrega sus tarjetas a la rejilla.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ee-cargar-mas]');
    if (!a || !window.fetch || !window.DOMParser) return;
    var rejilla = document.getElementById(a.getAttribute('data-rejilla'));
    var pie = document.getElementById(a.getAttribute('data-pie'));
    if (!rejilla || !pie) return;
    e.preventDefault();
    a.setAttribute('aria-busy', 'true');
    var etiqueta = a.querySelector('[data-ee-etiqueta]');
    var textoAntes = etiqueta ? etiqueta.textContent : '';
    if (etiqueta) etiqueta.textContent = 'Cargando…';

    fetch(a.href, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nueva = doc.getElementById(rejilla.id);
        var nuevoPie = doc.getElementById(pie.id);
        if (!nueva) throw new Error('sin rejilla');
        var items = Array.prototype.slice.call(nueva.children);
        items.forEach(function (li) {
          rejilla.appendChild(document.importNode(li, true));
        });
        if (nuevoPie) {
          var piePegado = document.importNode(nuevoPie, true);
          piePegado.querySelectorAll('[data-ee-anterior]').forEach(function (x) { x.remove(); });
          pie.replaceWith(piePegado);
        } else {
          pie.remove();
        }
        // Llevar el foco al primer producto nuevo (teclado y lectores de pantalla).
        var primero = rejilla.children[rejilla.children.length - items.length];
        var enlace = primero && primero.querySelector('a[href]');
        if (enlace) enlace.focus({ preventScroll: true });
      })
      .catch(function () {
        if (etiqueta) etiqueta.textContent = textoAntes;
        window.location.href = a.href;
      });
  });
})();
